import { fn } from "../setup";

fn.show   = function() {
	return this.toggle( true );
};
